/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Timing_Settings_FormInputs */

const en_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project timing settings form`)
};

const fr_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire des paramètres de minutage du projet`)
};

const de_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formular für Projektzeiteinstellungen`)
};

const it_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di impostazione dei tempi del progetto`)
};

const ru_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма настройки сроков проекта`)
};

const es_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de configuración de tiempos de proyecto`)
};

const zh_cn2_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目时间设置表`)
};

const ja_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトタイミング設定フォーム`)
};

const hi_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट समय सेटिंग फॉर्म`)
};

const pt_pt2_project_timing_settings_form = /** @type {(inputs: Project_Timing_Settings_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de configurações de tempo do projeto`)
};

/**
* | output |
* | --- |
* | "Project timing settings form" |
*
* @param {Project_Timing_Settings_FormInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_timing_settings_form = /** @type {((inputs?: Project_Timing_Settings_FormInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Timing_Settings_FormInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_timing_settings_form(inputs)
	if (locale === "de") return de_project_timing_settings_form(inputs)
	if (locale === "it") return it_project_timing_settings_form(inputs)
	if (locale === "ru") return ru_project_timing_settings_form(inputs)
	if (locale === "es") return es_project_timing_settings_form(inputs)
	if (locale === "zh-CN") return zh_cn2_project_timing_settings_form(inputs)
	if (locale === "ja") return ja_project_timing_settings_form(inputs)
	if (locale === "hi") return hi_project_timing_settings_form(inputs)
	if (locale === "pt-PT") return pt_pt2_project_timing_settings_form(inputs)
	return en_project_timing_settings_form(inputs)
});